<form *ngIf="form" [formGroup]="form" [editorType]="customFields.length > 0 ? 'small' : 'tiny'">
  <div class="column">
    <dx-text-area formControlName="name" formField required [label]="'entity.name' | translate | ucfirst" />
    <dx-select-box
      formControlName="dataTypeId"
      formField
      required
      [dataSource]="dataTypes"
      displayExpr="name"
      valueExpr="id"
      [label]="'entity.checkpoint.dataTypeId' | translate | ucfirst"
    />
    @if(form.controls['dataTypeId'].value === ECheckpointDataType.Sensor){
      <dx-lookup formControlName="values" formField [label]="'common.tabTitle.sensorTypes' | translate" [gsResource]="sensors"></dx-lookup>
    } @else {
      @if (form.controls['dataTypeId'].value === ECheckpointDataType.MultipleSelection || form.controls['dataTypeId'].value === ECheckpointDataType.UniqueSelection){
        <dx-tag-box
          formControlName="values"
          formField
          [label]="'entity.checkpoint.values' | translate | ucfirst"
          [acceptCustomValue]="true"
        />
      }
    }
  </div>
  <div class="column" *ngIf="customFields.length > 0">
    <app-custom-fields [fields]="customFields"></app-custom-fields>
  </div>
</form>
